export const HEADER_TRACE_KEY = 'X-Correlation-Id'

export const LOCAL_STORAGE_KEY = {
  TOKEN_PAYLOAD: 'token',
  URL_PERMISSION: 'url_permission',
  LANDING_PAGE:'landing_page',
  User_ID : 'User-ID',
  User_Name : 'User-Name'
}

export const ROUTES = {
  internalLogin: '/ilogin',
  logout: '/logout',
  landing: '/login'
}

export const SITE_KEY = '6Lc7J34nAAAAAJoy3iXfPz_Mfl-B_EBcdXOhBYum';
export const TEST_SITE_KEY = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';

export const AG_GRID_KEY = 'Using_this_AG_Grid_Enterprise_key_( AG-047631 )_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_( legal@ag-grid.com )___For_help_with_changing_this_key_please_contact_( info@ag-grid.com )___( Vector Management Consulting Pvt. Ltd. )_is_granted_a_( Single Application )_Developer_License_for_the_application_( VectorFLOW )_only_for_( 4 )_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_( VectorFLOW )_need_to_be_licensed___( VectorFLOW )_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_AG_Grid_Enterprise_versions_released_before_( 14 November 2024 )____[v2]_MTczMTU0MjQwMDAwMA==a93402becd854f72164cd6cbb067bdc2';

export const APPLICATION_NAMES = { "MTA": "Distribution", "MTO": "Orders" };
